import React from 'react';
import { Field, reduxForm } from 'redux-form';

import Input from '../../modules/Input';
import Button from '../../modules/Button';
import InputGroup from '../../modules/InputGroup';
import FormButtonPanel from '../../modules/FormButtonPanel';
import AlertBox from '../../modules/AlertBox';

import * as formScroller from '../../../services/forms/scroller';

import styles from './styles.scss';
import AlertMessage from "../../modules/AlertMessage/index";
import FormatAlertMessage from "../../modules/FormatAlertMessage/index";

import FieldSet from "../../modules/FieldSet";

const TwoFactorAuthentication = props => {
    if (!props.show) return null;

    const user = props.userAccount;
    let methodDisplayNames = [];

    user && user.auth_methods.map( method => {
       if (method.method === 'sms')  methodDisplayNames['sms'] = 'SMS Message';
       if (method.method === 'app')  methodDisplayNames['app'] = 'Google Authenticator App';
       if (method.method === 'email')  methodDisplayNames['email'] = 'Email';
    });

    return (
        <div>
            {user.auth_methods.map( method => {
                return (
                    <div className={styles['auth-container']}>
                        <strong>{ methodDisplayNames[method.method] }</strong>{ method.method === 'sms' && ( <span>(+{ user.telephone_auth.dial_code + ' ' +user.telephone_auth.telephone })</span>) }
                        { method.is_primary && ( <span className={styles['auth-method_primary']}> - Primary method</span>)}
                    </div>
                )}
            )}
        </div>
    );
}

class AdminAccount extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isShowingAuthMethods : false
        };

    }

    componentDidMount() {
        this.props.setInitialShowState(this.props.initialValues.mfa_active);
    }

    render() {

        const {
            submitSucceeded,
            submitFailed,
            handleSubmit,
            pristine,
            submitting,
            error
        } = this.props;

        return (
            <div>
                <AlertMessage>
                    {(submitSucceeded || submitFailed) && (
                        <AlertBox
                            theme={submitSucceeded ? "success" : 'danger'}
                        >
                            {submitSucceeded && (
                                'The account has been saved.'
                            )}
                            {submitFailed && error && (
                                <FormatAlertMessage
                                    genericMessage={'There was a problem saving the account.'}
                                    error={error}
                                />
                            )}
                        </AlertBox>
                    )}
                </AlertMessage>

                <form onSubmit={handleSubmit}>
                    <InputGroup>
                        <Field name="first_name" component={Input} type="text" label="First Name" required="true" />
                    </InputGroup>

                    <InputGroup>
                        <Field name="last_name" component={Input} type="text" label="Last Name" required="true" />
                    </InputGroup>

                    <InputGroup>
                        <Field name="email" component={Input} type="email" label="Email" required="true" />
                    </InputGroup>

                    <InputGroup>
                        <Field name="organisation" component={Input} label="Organisation" type="text" />
                    </InputGroup>

                    <InputGroup>
                        <Field name="job_title" component={Input} label="Job Title" type="text" />
                    </InputGroup>

                    <InputGroup>
                        <Field name="telephone" component={Input} label="Telephone" type="text" />
                    </InputGroup>

                    <InputGroup>
                        <Field name="password" component={Input} type="password" label="Password" />
                    </InputGroup>

                    <FieldSet legend="Two-Factor Authentication">
                        <InputGroup>
                            <Field name="mfa_active" component={Input} label="Use 2FA" type="checkbox" onChange={ this.props.on2FAChange } />
                        </InputGroup>
                        {this.props.initialValues && Object.keys(this.props.initialValues).length > 0 && (
                        <TwoFactorAuthentication
                            show={ this.props.isShowingAuthenticationMethods }
                            userAccount={this.props.initialValues}
                        />
                        )}
                    </FieldSet>

                    <InputGroup>
                        <Field name="confirmed" component={Input} label="Confirmed" type="checkbox" />
                    </InputGroup>

                    <FormButtonPanel position="bottom">
                        <Button disabled={pristine || submitting} type="submit">Save</Button>&nbsp; &nbsp;
                        <Button disabled={!this.props.isAccountLocked} onClick={() => this.props.unlockAccount(this.props.initialValues.id)}>Unlock Account</Button>
                    </FormButtonPanel>
                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'admin-account',
    onSubmitSuccess: formScroller.scrollToTop,
    onSubmitFail: formScroller.scrollToFirstError
})(AdminAccount);